import { fetchFeatureFlags } from "@/actions/featureFlags";
import { useAppDispatch, useAppSelector } from "@/hooks";
import { FeatureFlags } from "@/types/models/services/feature_flags";
import { FC, ReactNode, useEffect } from "react";

export interface Props {
  flagName: keyof FeatureFlags;
  children: ReactNode;
}
const FeatureFlag: FC<Props> = ({ children, flagName }) => {
  const dispatch = useAppDispatch();
  const { data, status } = useAppSelector(state => state.featureFlags);
  const { isAuthenticating } = useAppSelector(state => state.auth);

  useEffect(() => {
    if (!isAuthenticating && !data && !status.isLoading) {
      dispatch(fetchFeatureFlags());
    }
  }, [data, dispatch, isAuthenticating, status.isLoading]);

  if (data && flagName in data && data[flagName])
    return children;
  else if (!data)
    return children;
  return null;
};

export default FeatureFlag;
